import { render, staticRenderFns } from "./SellerDisclosureStatementPopup.vue?vue&type=template&id=be8f59e6&"
import script from "./SellerDisclosureStatementPopup.vue?vue&type=script&lang=js&"
export * from "./SellerDisclosureStatementPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports